export const SERVER_URL = process.env.VUE_APP_SERVER_URL;
